export const apiOptions = {
  apiRoot: window.REACT_API_ROOT || process.env.API_ROOT,
  apiRootNew: window.REACT_NEW_API_ROOT || process.env.REACT_APP_NEW_API_ROOT,
  appDomain: window.REACT_APP_DOMAIN || process.env.APP_DOMAIN,
  messageBrokerDomain: window.MESSAGE_BROKER_DOMAIN,
  messageBrokerWebSocket: window.MESSAGE_BROKER_WEB_SOCKET,
  appAssetsRootPath: window.REACT_ASSETS_ROOT_PATH || process.env.REACT_ASSETS_ROOT_PATH,
  pipelinesRouterBaseName: process.env.PIPELINES_ROUTER_BASE_NAME,
};
